import React from 'react';
import styled from 'styled-components/macro';
import { Icon, Menu } from 'antd';

import {
  URL_HS_SEARCH_HOST_PAGE,
  URL_HS_RENO_CALC_PAGE,
  URL_HS_ENQUIRY_PAGE,
  URL_HS_HOST_LISTING_PAGE,
  URL_HAS_MAIN_PAGE,
  URL_HAS_CAMPAIGN_PAGE,
  URL_HAS_HOST_PROTECT_PAGE,
  URL_HS_HOST_REGISTER_PAGE,
  URL_HAS_TEAM_PAGE,
  URL_HAS_EVENTS_PAGE,
  URL_HAS_BLOG_PAGE,
  URL_HAS_HOST_360,
  URL_HP_PAGE,
  URL_DAS_PAGE
} from 'utils/urls';
import HostAStayLogo from '../../images/has-logo-with-padding.png';

const { SubMenu, Item: MenuItem } = Menu;

const IconDiv = styled.div`
  height: 100%;
`;

const IconImg = styled.img`
  height: ${props => props.theme.header.mobile.iconHeight}px;

  @media (min-width: 768px) {
    height: ${props => props.theme.header.desktop.iconHeight}px;
  }
`;

const HostSearchIcon = () => (
  <IconDiv>
    <a href={URL_HAS_MAIN_PAGE}>
      <IconImg src={HostAStayLogo} />
    </a>
  </IconDiv>
);

const StyledHyperlink = styled.a`
  font-size: 14px;
  color: ${props => props.theme.color.white};
`;

const SiderMenu = ({ isCollapsed }) => (
  <Menu style={{ display: isCollapsed ? 'none' : 'block' }} mode="inline" defaultOpenKeys={['owner', 'host', 'about-us', 'event', 'resources']}>
    <MenuItem key="campaign">
      <StyledHyperlink href={URL_HAS_CAMPAIGN_PAGE}>Campaign</StyledHyperlink>
    </MenuItem>
    <SubMenu key="owner" title="Owner">
      <MenuItem key="search-host">
        <StyledHyperlink href={URL_HS_SEARCH_HOST_PAGE}>Search Host</StyledHyperlink>
      </MenuItem>
      <MenuItem key="reno-calculator">
        <StyledHyperlink href={URL_HS_RENO_CALC_PAGE}>Reno Calculator</StyledHyperlink>
      </MenuItem>
      <MenuItem key="enquiry">
        <StyledHyperlink href={URL_HS_ENQUIRY_PAGE}>Enquiry</StyledHyperlink>
      </MenuItem>
    </SubMenu>
    <SubMenu key="host" title="Host">
      <MenuItem key="host360">
        <StyledHyperlink href={URL_HAS_HOST_360}>
          Host360°
        </StyledHyperlink>
      </MenuItem>
      <MenuItem key="ourHostPartners">
        <StyledHyperlink href={URL_HS_HOST_LISTING_PAGE}>
          Our Host Partners
        </StyledHyperlink>
      </MenuItem>
      <MenuItem key="shortStayManagementSystem">
        <StyledHyperlink href={URL_HP_PAGE} target="_blank">
          Short Stay Management System
        </StyledHyperlink>
      </MenuItem>
      <MenuItem key="interiorDesignRenovation">
        <StyledHyperlink href={URL_DAS_PAGE} target="_blank">
          Interior Design & Renovation
        </StyledHyperlink>
      </MenuItem>
      <MenuItem key="shortStayInsurance">
        <StyledHyperlink href={URL_HAS_HOST_PROTECT_PAGE}>Short Stay Insurance</StyledHyperlink>
      </MenuItem>
      <MenuItem key="joinTheHostCommunity">
        <StyledHyperlink href={URL_HS_HOST_REGISTER_PAGE}>Join the Host Community</StyledHyperlink>
      </MenuItem>
    </SubMenu>
    <SubMenu key="about-us" title="About Us">
      <MenuItem key="our-team">
        <StyledHyperlink href={URL_HAS_TEAM_PAGE}>Our Team</StyledHyperlink>
      </MenuItem>
    </SubMenu>
    <SubMenu key="event" title="Events">
      <MenuItem key="upcoming-events">
        <StyledHyperlink href={URL_HAS_EVENTS_PAGE}>Upcoming Events</StyledHyperlink>
      </MenuItem>
    </SubMenu>
    <SubMenu key="resources" title="Resources">
      <MenuItem key="blog">
        <StyledHyperlink href={URL_HAS_BLOG_PAGE}>Blog</StyledHyperlink>
      </MenuItem>
    </SubMenu>
  </Menu>
);

const Root = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
Root.displayName = 'MobileHeader';

const MobileHeaderContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HostSearchIconContainer = styled.div`
  margin: 0 auto;
`;

const CollapseButtonContainer = styled.div`
  padding: 8px;
`;

const CollapseButtonIcon = styled(Icon)`
  font-size: 32px;
  color: ${props => props.theme.color.white};
`

const CollapseButton = ({ onClick }) => {
  return <CollapseButtonIcon type="bars" onClick={onClick} />;
};

const MobileHeader = ({ isCollapsed, onCollapse }) => {
  return (
    <Root>
      <MobileHeaderContentContainer>
        <HostSearchIconContainer>
          <HostSearchIcon />
        </HostSearchIconContainer>
        <CollapseButtonContainer>
          <CollapseButton onClick={onCollapse} />
        </CollapseButtonContainer>
      </MobileHeaderContentContainer>
      <SiderMenu isCollapsed={isCollapsed} />
    </Root>
  );
};

export default MobileHeader;
